export default __webpack_public_path__ + "static/media/weepinbellModel.5773b2f2.glb";